import OnboardingTunnel from './OnboardingTunnel';

export default OnboardingTunnel;
